// extracted by mini-css-extract-plugin
export default {"scheduleBlock":"Schedule_scheduleBlock__+6HMz","scheduleTitle":"Schedule_scheduleTitle__z6rid","scheduleTable":"Schedule_scheduleTable__j60qd"};